import type { ComponentTemplate } from "schemas/generated/componentTemplates";

import { transformReviewsTemplateToUseProductForContextIfNecessary } from "./defaultComponentTemplate";

export const yotpoProductRating: ComponentTemplate = {
  id: "e1c35c8a-062c-424f-88dd-7ef623d55909",
  storeId: null,

  scope: "left-bar",
  type: "component",
  name: "Product/Yotpo Product Rating",
  leftBarCategory: { main: "productIntegrations", subCategory: "yotpo" },
  preview: "integrations/yotpo-product-rating.svg",
  transforms: [transformReviewsTemplateToUseProductForContextIfNecessary],
  tags: ["reviews", "star"],
  template: {
    id: "$uid",
    type: "yotpoProductRating",
    props: {},
  },
};
